import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-single',
    templateUrl: './single.component.html',
    styleUrls: ['./single.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SingleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
